import type { MeterBaseProviderOptions } from '@vtex/diagnostics-core'
import { MeterBaseProvider } from '@vtex/diagnostics-core'
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http'

import pkg from '../../package.json'

interface BrowserExporterOptions
  extends Omit<MeterBaseProviderOptions['readerOptions'], 'exporter'> {
  url: string
}

interface BrowserMetricsOptions
  extends Omit<MeterBaseProviderOptions, 'readerOptions'> {
  readerOptions: BrowserExporterOptions
}

export const Metrics = {
  create({
    readerOptions: { url, exportIntervalMillis, exportTimeoutMillis },
    service,
  }: BrowserMetricsOptions) {
    const metricExporter = new OTLPMetricExporter({
      url,
    })

    const meterProvider = MeterBaseProvider.create({
      readerOptions: {
        exporter: metricExporter,
        exportIntervalMillis,
        exportTimeoutMillis,
      },
      service,
    })

    if (typeof window !== 'undefined' && 'addEventListener' in window) {
      window.addEventListener('beforeunload', () => {
        meterProvider.forceFlush()
      })
    }

    return meterProvider.getMeter(pkg.name, pkg.version)
  },
}
